import { Sun, Moon, Monitor } from 'lucide-react'
import { useTheme } from './ThemeProvider'

// Segmented control de tema (Claro / Escuro / Auto) — estilo Sol Magazine.
const OPTS = [
  { v: 'light', Icon: Sun, label: 'Claro', tip: 'Tema claro' },
  { v: 'dark', Icon: Moon, label: 'Escuro', tip: 'Tema escuro' },
  { v: 'auto', Icon: Monitor, label: 'Auto', tip: 'Misto — menu escuro, conteúdo claro' },
]

export default function ThemeToggle({ showLabels = true }) {
  const { mode, setMode } = useTheme()
  return (
    <div role="group" aria-label="Alternar tema visual"
      className="tc-theme-toggle inline-flex items-center gap-0.5 p-1 rounded-full">
      {OPTS.map(({ v, Icon, label, tip }) => (
        <button key={v} type="button" onClick={() => setMode(v)} aria-pressed={mode === v} title={tip}
          className={`tc-tt-btn inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold transition-colors ${mode === v ? 'is-active' : ''}`}>
          <Icon size={14} />
          {showLabels && <span>{label}</span>}
        </button>
      ))}
    </div>
  )
}
